export default {
  'enabled-locations-map': {
    locations: 'Standorte',
    'find-my-location': 'Meinen Standort finden',
    'select-country': 'Land auswählen',
    'all-countries': 'Alle Länder',
    search: 'Suchen',
    filter: 'Nach Anbieter, Stadt, Land oder Bundesland filtern',
    'location-type': 'Standorttyp',
    '100G-enabled': '100G-fähig',
    'local-ix-available': 'Lokales IX verfügbar',
    'mcr-enabled': 'MCR-fähig',
    'mve-enabled': 'MVE-fähig',
    'view-latency': 'Latenz anzeigen',
    'enquire-about-this-location': 'Informationen zu diesem Standort anfragen',
    'enabled-location': 'Aktivierter Standort',
    'extended-location': 'Ergänzender Standort',
    'loading-locations': 'Standorte werden geladen',
    'no-location-found': 'Kein Standort erfüllt die Filterkriterien',
    'closest-mp-enabled-location': 'Der nächste aktivierte Megaport-Standort ist',
    'location-filter': 'Standortfilter',
    'coming-soon': 'Demnächst verfügbar',
    'enter-your-address': 'Geben Sie Ihre Adresse ein',
    'learn-about-enabled-extended-locations': 'Erfahren Sie mehr über unsere Aktivierten Standorte und Ergänzenden Standorte',
    'megaport-supported-location-types': 'Megaport unterstützt zwei Standorttypen, über die Sie unser Netzwerk erreichen können',
    'locations-by-distance': 'Standorte nach Entfernung',
    'map-showing-data-center-location': 'Karte, die den Standort des Rechenzentrums zeigt',
  },
}
  
